import { RM04_01 } from "./RM04_01";

export const RM04 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 2,
    type: "stacked",
    colorTheme: "colorTheme1",
    title: "Stocks Trend Based On Number Of Branches Covered",
    orientation: "horizontal",
    xAxis: "",
    yAxis: "",
    binding: {
      data: {
        series: [
          {
            name: "OOS",
            value: "OutOfStock",
          },
          {
            name: "Not Carried",
            value: "NotCarried",
          },
          {
            name: "Carried",
            value: "Carried",
          },
          {
            name: "For Deletion",
            value: "ForDeletion",
          },
          {
            name: "Deleted",
            value: "Deleted",
          },
          {
            name: "Available",
            value: "Available",
          },
        ],
        title: "ItemName",
        endpoint: "RM04",
        parameters: [
          { key: "FromMonth", value: "CP1" },
          { key: "FromYear", value: "2026" },
          { key: "ToMonth", value: "CP1" },
          { key: "ToYear", value: "2026" },
          { key: "RegionCode", value: "" },
        ],
      },
      context: {
        point: {
          onClick: RM04_01,
        },
      },
    },
  },
};
